import DigitalProductStore from "%/dynamic-component-editor/standard-elements/DigitalProductStore.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyDigitalProductStore extends LegacyEntity {
  get elements() {
    return {
      DigitalProductStore,
    };
  }
}
